
const valueSetObj = {
    'CURRENCY': 'CURRENCY',//币种
    'MAIN_ACCOUNT': 'MAIN_ACCOUNT',//主账套
    'BUSINESS_ENTITY': 'BUSINESS_ENTITY',//业务实体
    'LEGAL_ENTITY': 'LEGAL_ENTITY',//法人实体
    'TAX_LOGIC': 'TAX_LOGIC',//计税逻辑
    'DEDUCTIBLE': 'DEDUCTIBLE',//可否抵扣
    'REGION': 'REGION',//国家和地区
    'TAX_TYPE': 'TAX_TYPE',//税种
    'DEDUCTIBLE': 'DEDUCTIBLE',//可否抵扣
    'TAX_LOGIC': 'TAX_LOGIC',// 计算逻辑
    'COST_CENTER': 'COST_CENTER',//成本中心
    'OU_NAME': 'OU_NAME',//公司主体
    'TRANSACTION_TYPE': 'TRANSACTION_TYPE',//事务处理类型
    'LEASE_ITEM_TYPE': 'LEASE_ITEM_TYPE', //租赁物件类型
    'DISCOUNT_RATE_SOURCE': 'DISCOUNT_RATE_SOURCE',//折现率来源
    'LEASE_TYPE': 'LEASE_TYPE', //租赁类型
    'SOURCE': 'SOURCE', //数据来源
    'MAPPING_NAME': 'MAPPING_NAME', //映射名称
    'SUBJECT_TYPE': 'SUBJECT_TYPE', //场景类型
    'SUBJECT_TYPE_EN': 'SUBJECT_TYPE_EN', //场景类型
    'DOCUMENT_TYPE': 'DOCUMENT_TYPE', //凭证场景类型
    'DOCUMENT_TYPE_EN': 'DOCUMENT_TYPE_EN', //凭证场景类型
    'SUBENTRY_LINE_TYPE': 'SUBENTRY_LINE_TYPE', //分录行场景
    'SUBENTRY_LINE_TYPE_EN': 'SUBENTRY_LINE_TYPE_EN', //分录行场景
    'SUBJECT_ROW_NAME': 'SUBJECT_ROW_NAME', //科目列名
    'DR_OR_CR_FLAG': 'DR_OR_CR_FLAG', //借贷方向
    'DISCOUNT_RATE_TYPE': 'DISCOUNT_RATE_TYPE', //利率类型
}

export default valueSetObj



// WEBPACK FOOTER //
// ./src/api/common/valueSetObj.js